/** Dashboard / resources pages: slug → role filter + page title */
export const EMS_RESOURCE_ROLES = {
  trainers: {
    slug: "trainers",
    roleName: "Trainer",
    title: "Trainers",
    countLabel: "trainers",
  },
  trainer: {
    slug: "trainers",
    roleName: "Trainer",
    title: "Trainers",
    countLabel: "trainers",
  },
  counselors: {
    slug: "counselors",
    roleName: "Counselor",
    title: "Counselors",
    countLabel: "counselors",
  },
  counselor: {
    slug: "counselors",
    roleName: "Counselor",
    title: "Counselors",
    countLabel: "counselors",
  },
};

export const pluralizeRoleTitle = (roleName) => {
  const name = String(roleName || "").trim();
  if (!name) return "Users";
  if (/s$/i.test(name)) return name;
  return `${name}s`;
};

export const getResourceRoleFromSlug = (slug) => {
  const key = String(slug || "")
    .trim()
    .toLowerCase();
  return EMS_RESOURCE_ROLES[key] || null;
};

export const getResourceRoleByName = (roleName) => {
  const normalized = String(roleName || "").trim().toLowerCase();
  if (!normalized) return null;

  const match = Object.values(EMS_RESOURCE_ROLES).find(
    (entry) => String(entry.roleName).toLowerCase() === normalized
  );
  if (match) return match;

  return {
    roleName: String(roleName).trim(),
    title: pluralizeRoleTitle(roleName),
    countLabel: pluralizeRoleTitle(roleName).toLowerCase(),
  };
};

export const buildUsersSearchParamsForRole = (roleName, extra = {}) => {
  const params = new URLSearchParams({
    page: "1",
    pageSize: "10",
    sortBy: "application_user_full_name",
    sortOrder: "asc",
    filter_application_user_role_id_name: roleName,
    filter_application_user_role_id_name_operator: "equals",
    ...extra,
  });
  return params;
};

export const resolveActiveResourceRole = (searchParams, resourceRoleConfig = null) => {
  if (resourceRoleConfig?.title) {
    return resourceRoleConfig;
  }

  const roleValue = searchParams?.get("filter_application_user_role_id_name");
  const operator =
    searchParams?.get("filter_application_user_role_id_name_operator") || "contains";

  if (!roleValue || operator !== "equals") {
    return null;
  }

  const roleName = String(roleValue).split(",")[0].trim();
  return getResourceRoleByName(roleName);
};

export const navigateToResourceRole = (navigate, roleSlug) => {
  navigate(`/resources/${String(roleSlug || "").trim().toLowerCase()}`);
};
